import { NgModule } from '@angular/core';
import { CallbackFeatureModule, CallbackModalLinkListenerService } from '@callback/feature';

@NgModule({
  imports: [CallbackFeatureModule],
})
export class CallbackShellModule {
  constructor(callbackModalLinkListenerService: CallbackModalLinkListenerService) {
    void callbackModalLinkListenerService;
  }
}
